module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4607-8741e34fbe88af7200e5cd956b7fd8cc.jpg";